import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import Loader from './Widget/Loader';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Actions } from "../redux/DictionaryRedux";
import { ApiServices } from "../utils/ApiServices";
// context
const loading = () => <Loader />;

const Layout = React.lazy(() => import('./Layout/Layout'));
const Login = React.lazy(() => import('../pages/account/Login'));
const Error = React.lazy(() => import('../pages/error/Error'));
export default function App() {
  // global

  const [loadDic, setLoadDic] = useState(true);
  const dispatch = useDispatch();
  const loadDictionary = async () => {
    let lan = localStorage.getItem('current_lan');
    if (!lan) {
      lan = 'fa';
      localStorage.setItem('current_lan', lan);
    }
    var result = await ApiServices.translations.get(lan);
    if (result) {
      var data = result;
      dispatch(Actions.SetDictionary(data.translations));
      setLoadDic(false);
    }

  }
  useEffect(function () {
    loadDictionary();
  }, []);
  return (loadDic ? (<Loader />) :
    <BrowserRouter>
      <React.Suspense fallback={loading()}>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/app/dashboard" />} />
          <Route
            exact
            path="/app"
            render={() => <Redirect to="/app/dashboard" />}
          />
          <Route path="/app" component={Layout} />
          <Route path="/login" component={Login} />
          <Route component={Error} />
        </Switch>
      </React.Suspense>
      <ToastContainer />
    </BrowserRouter>
  );

}
